/* eslint-disable react/no-unused-class-component-methods */
import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

import isEqual from 'lodash/isEqual';

import ModificationTrackingForm from '../components/modificationTrackingForm';

const STRING_FIELD_TYPES = ['Date', 'Text', 'TextArea'];

const ModificationTrackingFormContainer = createReactClass({
  propTypes: {
    formPrepend: PropTypes.node,
    onCancelClick: PropTypes.func,
    onSaveClick: PropTypes.func.isRequired,
    onFormUpdate: PropTypes.func,
    model: PropTypes.objectOf(PropTypes.any).isRequired,
    schema: PropTypes.objectOf(PropTypes.any).isRequired,
    onError: PropTypes.func,
    isDisabled: PropTypes.bool,
  },

  getDefaultProps() {
    return {
      formPrepend: null,
      onCancelClick: () => {},
      onFormUpdate: () => {},
      onError: () => {},
      isDisabled: false,
    };
  },

  getInitialState() {
    return {
      modifiedModel: this.props.model,
      isSaveButtonDisabled: true,
      isSubmittingForm: false,
    };
  },

  onFormLoad({ hasError }) {
    this.setState({ isSaveButtonDisabled: hasError });
  },

  onFormUpdate(onFormUpdateArgs) {
    const { update, hasError } = onFormUpdateArgs;
    const { modifiedModel: preUpdateModel } = this.state;
    const { onFormUpdate } = this.props;
    const modifiedModel = { ...preUpdateModel, ...update };

    this.setState({ modifiedModel, isSaveButtonDisabled: hasError });

    onFormUpdate(onFormUpdateArgs);
  },

  async onSaveClick() {
    const { onSaveClick, onError } = this.props;
    const { modifiedModel } = this.state;

    this.setState({ isSubmittingForm: true });

    try {
      await onSaveClick({ modifiedModel });
    } catch (error) {
      onError(error);
    }

    this.setState({ isSubmittingForm: false });
  },

  onCancelClick() {
    const { model, onCancelClick } = this.props;

    this.setState({ modifiedModel: model });
    onCancelClick({ model });
  },

  // transform null string fields in response data to ''
  // https://github.com/intellum/exceed/issues/50491
  getNormalisedModel() {
    const { model, schema } = this.props;
    const { modifiedModel } = this.state;

    return Object.entries(schema).reduce((a, [key, { type }]) => (
      STRING_FIELD_TYPES.includes(type) && !model[key] && modifiedModel[key] === ''
        ? { ...a, [key]: '' }
        : a
    ), { ...model });
  },

  render() {
    const { modifiedModel, isSaveButtonDisabled, isSubmittingForm } = this.state;

    const {
      className,
      formPrepend,
      modifiedClassName,
      schema,
      isDisabled,
    } = this.props;

    const isModelModified = !isEqual(this.getNormalisedModel(), modifiedModel);

    return (
      <ModificationTrackingForm
        className={className}
        formPrepend={formPrepend}
        isModelModified={isModelModified}
        isSaveButtonDisabled={isSaveButtonDisabled}
        isSubmittingForm={isSubmittingForm}
        isDisabled={isDisabled}
        schema={schema}
        model={modifiedModel}
        modifiedClassName={modifiedClassName}
        onFormUpdate={this.onFormUpdate}
        onFormLoad={this.onFormLoad}
        onSaveClick={this.onSaveClick}
        onCancelClick={this.onCancelClick}
      />
    );
  },
});

export default ModificationTrackingFormContainer;
